import React, { useState } from "react";

import {
  RESULT_DEFAULTS,
  RESULT_ICONS,
  formatDate,
} from "./competition.constants";

/**
 * Cevap (ya da günün) sonucu. Metin sunucudan gelir (sabit metinler); gelmezse sonuç türüne göre
 * yedek metin gösterilir. Görsel sonuç türünün ikonudur; kazanımda hediye görseli (yoksa başarı
 * ikonu). "Kazandınız" yalnızca kazanım kesinleştiyse (WON).
 */
const ResultCard = ({ result, unitName, finalStartDate, onNext }) => {
  const [copied, setCopied] = useState(false);
  const defaults = RESULT_DEFAULTS[result?.kind] || RESULT_DEFAULTS.CORRECT;
  const message = result?.message || defaults.message;
  const image =
    (result?.kind === "WON" && result?.giftImageUrl) ||
    RESULT_ICONS[defaults.icon];

  const copyCode = () => {
    if (!result?.awardCode || !navigator.clipboard) return;
    navigator.clipboard
      .writeText(result.awardCode)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch(() => {});
  };

  return (
    <div
      className={`cmp-card-body cmp-center cmp-result cmp-result-${defaults.tone}`}
    >
      <h2 className="cmp-result-title">{defaults.title}</h2>
      {result?.finalQualifiedNow && (
        <p className="cmp-final-qualified">
          Finale girişe hak kazandınız!
          {finalStartDate &&
            ` Final ${formatDate(finalStartDate)} tarihinde başlıyor.`}
        </p>
      )}
      {image && (
        <div className="cmp-media">
          <img
            className="cmp-result-image"
            src={image}
            alt={result?.giftName || ""}
          />
        </div>
      )}
      <p className="cmp-result-message">{message}</p>

      {result?.kind === "WON" && result?.awardCode && (
        <div className="cmp-award-code">
          <span className="cmp-award-code-label">Kazanım Kodunuz</span>
          <strong>{result.awardCode}</strong>
          <button type="button" className="cmp-link-btn" onClick={copyCode}>
            {copied ? "Kopyalandı" : "Kopyala"}
          </button>
          <span className="cmp-award-code-hint">
            Lütfen bu kodu not ediniz.
          </span>
        </div>
      )}

      {result?.unitsRequired > 0 && (
        <div className="cmp-final-progress">
          <div className="cmp-final-progress-label">
            Final: {result.units || 0} / {result.unitsRequired} {unitName || ""}
            {result.finalQualified && (
              <span className="cmp-badge">Finale girişe hak kazandınız</span>
            )}
          </div>
          <div className="cmp-progress">
            <span
              style={{
                width: `${Math.min(100, ((result.units || 0) / result.unitsRequired) * 100)}%`,
              }}
            />
          </div>
        </div>
      )}

      {onNext && (
        <button
          type="button"
          className="cmp-btn cmp-btn-primary"
          onClick={onNext}
        >
          Sıradaki Soruya Geç
        </button>
      )}
    </div>
  );
};

export default ResultCard;
